import { useId } from "react"
import type { ReactNode } from "react"
import Dialog from "@mui/material/Dialog"
import type { DialogProps } from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import CloseIcon from "@mui/icons-material/Close"

import SectionHeader from "./SectionHeader"

interface PopUpProps extends Omit<DialogProps, "onClose"> {
  onClose: () => void
  /** Header with the title and a close button. The title also names the dialog. */
  titleKey?: string
  /** Footer, aligned to the right. */
  actions?: ReactNode
  /** Content that fills the dialog edge to edge. */
  disableGutters?: boolean
}

// The one dialog: an optional header, the content, and an optional footer.
const PopUp = ({
  titleKey,
  actions,
  disableGutters = false,
  onClose,
  children,
  ...dialogProps
}: PopUpProps) => {
  const titleId = useId()

  return (
    <Dialog onClose={onClose} aria-labelledby={titleId} {...dialogProps}>
      {titleKey && (
        <SectionHeader
          id={titleId}
          titleKey={titleKey}
          handleAction={onClose}
          actionIcon={<CloseIcon fontSize="small" color="action" />}
          actionLabelKey="generic.CLOSE"
        />
      )}
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", p: disableGutters ? 0 : 2.5 }}
      >
        {children}
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  )
}

export default PopUp
